import { useQuery } from "@tanstack/react-query";
import { getUserById } from "../containers/newBackendApi/newUser";

export const userKeys = {
  all: () => ["users"],
  detail: (userId) => ["users", "detail", userId],
};

export const useGetUserById = (userId, options = {}) => {
  return useQuery({
    queryKey: userKeys.detail(userId),
    queryFn: () => getUserById(userId),
    enabled: !!userId && options.enabled !== false,
    ...options,
  });
};
